'use client'
import classNames from 'classnames'
import React from 'react'
import { isAndroid } from 'react-device-detect'

import Icons from '@/shared/components/icon/Icons'

import { MarkerType } from '@/enums/map'

interface PoiIconProps {
  name: string
  price?: string
  markerType: MarkerType
  isOn?: boolean
}

const PoiWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className={classNames(`relative h-full w-full`, isAndroid && 'prevent-render-overhead')}>{children}</div>
}

const PoiIcon = ({ name, price, markerType, isOn = false }: PoiIconProps) => {
  const activeBgStyle = 'border-[#163D56] bg-[#224D6A] before:bg-[#224D6A] after:bg-[#163D56]'
  const NormalPOI = ({ price }: Pick<PoiIconProps, 'price'>) => {
    return (
      <PoiWrapper>
        <div className={`relative z-[10] flex h-[30px] flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex h-[28px] cursor-pointer items-center justify-center rounded-[20px] border
          text-center before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg]
         before:skew-y-[13deg] before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
           isOn
             ? `${activeBgStyle} text-[#ffffff]`
             : 'border-[#263238] bg-[#ffffff] text-[#263238] before:bg-[#ffffff] after:bg-[#263238]'
         }`}
          >
            <div className={`z-[3] flex w-[100%] min-w-[60px] flex-col items-center justify-center `}>
              <div className={`mx-[12px] text-[17px] leading-[17px]`}>{price}</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const NormalCurrentFreePOI = () => {
    return (
      <PoiWrapper>
        <div className={`relative z-[10] flex h-[30px] flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex h-[28px] cursor-pointer items-center justify-center rounded-[20px] border 
          text-center before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg] before:skew-y-[13deg]
          before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
            isOn
              ? `${activeBgStyle} text-[#ffffff]`
              : 'border-[#263238] bg-[#ffffff] text-[#263238] before:bg-[#ffffff] after:bg-[#263238]'
          }`}
          >
            <div className={`z-[3] flex w-[100%] flex-col items-center justify-center whitespace-nowrap`}>
              <div className={`mx-[12px] text-[17px] font-regular leading-[26px]`}>현재무료</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const NormalAlwaysFreePOI = () => {
    return (
      <PoiWrapper>
        <div className={`relative z-[10] flex h-[30px] flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex h-[28px] cursor-pointer items-center justify-center rounded-[20px] border 
          text-center before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg] before:skew-y-[13deg]
          before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
            isOn
              ? `${activeBgStyle} text-[#ffffff]`
              : 'border-[#263238] bg-[#ffffff] text-[#263238] before:bg-[#ffffff] after:bg-[#263238]'
          }`}
          >
            <div className={`z-[3] flex w-[100%] flex-col items-center justify-center whitespace-nowrap`}>
              <div className={`mx-[12px] text-[17px] font-regular leading-[26px]`}>상시무료</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const NormalNoPriceInfo = () => {
    return (
      <PoiWrapper>
        <div className={`relative z-[10] flex h-[30px] flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex h-[28px] cursor-pointer items-center justify-center rounded-[20px] border
          text-center before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg] before:skew-y-[13deg]
          before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] after:bg-[#263238] ${
            isOn
              ? `${activeBgStyle} text-[#ffffff]`
              : 'border-[#263238] bg-[#ffffff] text-[#263238] before:bg-[#ffffff] after:bg-[#263238]'
          }`}
          >
            <div className={`z-[3] flex w-[100%] min-w-[60px] flex-col items-center justify-center`}>
              <div className={`mx-[12px] text-[17px] leading-[26px]`}>P</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const NormalDisabledPOI = ({ price }: Pick<PoiIconProps, 'price'>) => {
    return (
      <PoiWrapper>
        <div className={`relative z-[10] flex h-[30px] flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex h-[28px] cursor-pointer items-center justify-center rounded-[20px] border 
           text-center before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg] before:skew-y-[13deg]
          before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
            isOn
              ? `${activeBgStyle} text-[#ffffff]`
              : 'border-[#6D7D90] bg-[#B8C3D0] text-[#FFFFFF] before:bg-[#B8C3D0] after:bg-[#6D7D90]'
          }`}
          >
            <div className={`z-[3] flex w-[100%] min-w-[60px] flex-col items-center justify-center `}>
              <div className={`mx-[12px] mt-[2px] text-[17px] leading-[17px]`}>{price}</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const PartnerWithoutTicketPOI = ({ price }: Pick<PoiIconProps, 'price'>) => {
    return (
      <PoiWrapper>
        <div className={`relative z-[12] flex h-[30px] w-[100%] min-w-[67px] flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex h-[28px] cursor-pointer items-center justify-center rounded-[20px] border
             text-center before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg]
            before:skew-y-[13deg] before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
              isOn
                ? `${activeBgStyle} text-[#ffffff]`
                : 'border-[#263238] bg-[#ffffff] text-[#263238] before:bg-[#ffffff] after:bg-[#263238]'
            }`}
          >
            <div
              className={`ml-[2px] mr-1 flex h-[22px] w-[22px] items-center justify-center rounded-[100%] bg-[#0099FF] text-[10px] font-medium text-white`}
            >
              제휴
            </div>
            <div className={`z-[3] mr-[10px] flex min-w-[30px] flex-col items-center justify-center`}>
              <div className={`text-[17px] font-medium leading-[17px]`}>{price}</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const PartnerWithTicketPOI = ({ name, price }: Pick<PoiIconProps, 'name' | 'price'>) => {
    return (
      <PoiWrapper>
        <div className={`relative z-[13] flex h-12 flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex cursor-pointer items-center justify-center rounded-[4px] border 
             text-center text-[#ffffff] before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg]
            before:skew-y-[13deg] before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
              isOn ? activeBgStyle : 'border-[#0072BE] bg-[#0099FF] before:bg-[#0099FF] after:bg-[#0072BE]'
            }`}
          >
            <div
              className={`z-[3] mb-[6px] mt-[7px] min-w-[80px] flex-col items-center justify-center px-[12px] text-[#ffffff]`}
            >
              <div className={`mb-[4px] whitespace-nowrap text-[12px] leading-[12px]`}>{name}</div>
              <div className={`text-[17px] font-medium leading-[17px]`}>{price}</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const PartnerWithTicketDisabledPOI = ({ name, price }: Pick<PoiIconProps, 'name' | 'price'>) => {
    return (
      <PoiWrapper>
        <div className={`relative z-[11] flex h-12 flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex cursor-pointer items-center justify-center rounded-[4px] border 
             text-center before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg] before:skew-x-[13deg] before:skew-y-[13deg]
            before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
              isOn ? activeBgStyle : 'border-[#6D7D90] bg-[#B8C3D0] before:bg-[#B8C3D0] after:bg-[#6D7D90]'
            }`}
          >
            <div
              className={`z-[3] mb-[6px] mt-[7px] flex w-auto min-w-[80px] flex-col items-center justify-center px-3 text-[#ffffff]`}
            >
              <div className={`mb-[4px] whitespace-nowrap text-[12px] leading-[12px]`}>{name}</div>
              <div className={`text-[17px] font-medium leading-[17px]`}>{price}</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const SharingPOI = ({ price }: Pick<PoiIconProps, 'price'>) => {
    return (
      <PoiWrapper>
        <div className={`relative z-[12] flex h-[30px] w-[100%] min-w-[67px] flex-col items-center`}>
          <div
            className={`before:contents[''] after:contents[''] relative flex h-[28px] cursor-pointer items-center justify-center rounded-[20px] border
             text-center text-[#ffffff] before:absolute before:bottom-[-2px] before:z-[2] before:h-[10px] before:w-[10px] before:rotate-[45deg]
            before:skew-x-[13deg] before:skew-y-[13deg] before:rounded-[1px] after:absolute after:bottom-[-4px] after:z-[-3] after:h-[10px] after:w-[10px] after:rotate-[45deg] after:skew-x-[13deg] after:skew-y-[13deg] after:rounded-[2px] ${
              isOn ? activeBgStyle : 'border-[#0072BE] bg-[#0099FF] before:bg-[#0099FF] after:bg-[#0072BE]'
            }`}
          >
            <div
              className={`ml-[2px] mr-1 flex h-[22px] w-[22px] items-center justify-center rounded-[100%] bg-white text-[10px] font-medium text-[#0099FF]`}
            >
              공유
            </div>
            <div
              className={`z-[3] mr-[8px] min-w-[30px] flex-col items-center justify-center leading-none text-[#ffffff]`}
            >
              <div className={`text-[17px] font-medium leading-[17px]`}>{price}</div>
            </div>
          </div>
        </div>
        <div className={`absolute -bottom-[10px] right-1/2 h-[6px] w-[12px] translate-x-1/2`}>
          <Icons.PinShadowIcon />
        </div>
      </PoiWrapper>
    )
  }

  const POI = ({ markerType }: { markerType: MarkerType }) => {
    switch (markerType) {
      case MarkerType.Normal:
        return <NormalPOI price={price} />
      case MarkerType.NormalCurrentFree:
        return <NormalCurrentFreePOI />
      case MarkerType.NormalAlwaysFree:
        return <NormalAlwaysFreePOI />
      case MarkerType.NormalNoPriceInfo:
        return <NormalNoPriceInfo />
      case MarkerType.NormalDisabled:
        return <NormalDisabledPOI price={price} />
      case MarkerType.PartnerWithTicket:
        return <PartnerWithTicketPOI name={name} price={price} />
      case MarkerType.PartnerWithTicketDisabled:
        return <PartnerWithTicketDisabledPOI name={name} price={price} />
      case MarkerType.PartnerWithoutTicket:
        return <PartnerWithoutTicketPOI price={price} />
      case MarkerType.Sharing:
        return <SharingPOI price={price} />
      default:
        return <NormalPOI price={price} />
    }
  }

  return <POI markerType={markerType} />
}

export default PoiIcon
